<script lang="ts">
	import type { IColumn, TAreasMeta, DataStore } from "@xbs/lib-kanban";

	import HeaderCard from "./HeaderCard.svelte";

	export let columns: IColumn[];
	export let areasMeta: TAreasMeta;
	export let store: DataStore;
	export let contentEl: HTMLElement;

</script>

<div class="wx-header">
	{#each columns as column, index (column.id)}
		<HeaderCard
			{column}
			columnIndex={index}
			{contentEl}
			{store}
			{areasMeta}
			{columns}
			on:action />
	{/each}
</div>

<style>
	/* [todo] add ability to disable list item to wx, remove this block  */
	:global([data-id="wx-list-disabled"]) {
		opacity: 0.5;
		pointer-events: none;
	}
	.wx-header {
		display: flex;
		flex-direction: row;
		position: relative;

		padding: var(--wx-padding) 0;

		height: var(--wx-kanban-header-height);
		min-height: var(--wx-kanban-header-height);
	}

</style>
